import { EMPLOYER_CONTACT_US_URL } from '@seek/shared-constants';
import { useTranslations } from '@vocab/react';
import { Alert, Stack, Strong, Text, TextLink, Box } from 'braid-design-system';
import { useEffect } from 'react';

import translations from './.vocab';
import { useAppContext } from 'src/App/context/AppContext';
import { useTracking } from 'src/App/context/TrackingProvider';

export const CheckoutErrorSection = () => {
  const { site } = useAppContext();
  const { t } = useTranslations(translations);
  const { trackLink } = useTracking();

  useEffect(
    () => {
      trackLink({
        eventName: 'alert_viewed',
        data: {
          actionOrigin: 'upgrade',
          alertShown: [
            {
              alertShownTone: 'critical',
              alertShownType: 'notification',
              alertShownTitle: 'Can we try that again',
              alertShownMessageCode: 'ConfirmInvoiceOrderError',
            },
          ],
          currentPage: 'seek contract checkout',
        },
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const contactUsLink = EMPLOYER_CONTACT_US_URL[site];
  return (
    <Box marginY="medium">
      <Alert tone="critical">
        <Stack space="small">
          <Text>
            <Strong>{t('Can we try that again')}</Strong>
          </Text>
          <Text>
            {t('Try refreshing the page or check back later')}{' '}
            {t('If it still doesn’t work, reach out to our...', {
              CustomerServiceLink: (children) => (
                <TextLink href={contactUsLink} target="_blank">
                  {children}
                </TextLink>
              ),
            })}
          </Text>
        </Stack>
      </Alert>
    </Box>
  );
};
